import { useMemo } from 'react';

export const useBrandNormalization = (brands: string[], selectedBrands: string[]) => {
    return useMemo(() => {
        if (!selectedBrands.length) return selectedBrands;
        if (!brands.length) return selectedBrands;

        return selectedBrands
            .map(filterBrand => {
                if (brands.includes(filterBrand)) return filterBrand;

                const matchedBrand = brands.find(apiBrand =>
                    apiBrand.toLowerCase() === filterBrand.toLowerCase()
                );
                return matchedBrand || filterBrand;
            })
            .filter(brand =>
                brands.length === 0 || brands.some(availableBrand =>
                    availableBrand.toLowerCase() === brand.toLowerCase()
                )
            );
    }, [brands, selectedBrands]);
};